/**
 * common.ts
 * ----------------
 * Commonly used data transfer objects (DTOs) and type guards.
 */

/**
  * Standard JSON response from API.
  */
export type ApiResponse<T> = T | MessageResponse;

/**
 * Standard JSON response from API for bulk requests.
 */
export interface BulkApiResponse<T> {
    errors?: MessageResponse[];
    successfulResults?: T[];
}

/**
 * Standard JSON response with a message.
 */
export interface MessageResponse {
    message: string;
}

/**
 * Type guard: check if an ApiResponse is a MessageResponse.
 * @param apiResponse ApiResponse
 * @returns True if instance is MessageResponse, false otherwise.
 */
export function isMessageReponse<T> (apiResponse: ApiResponse<T>): apiResponse is MessageResponse {
    return (apiResponse as MessageResponse).message !== undefined;
}
